import {
  Glass,
  Dot,
  ScreenLabel,
  DisplayText,
  BodyText,
  Chevron,
} from "../../components/mobile/primitives";

// ─── Library rows ───────────────────────────────────────────────────────────

const LIBRARY_ITEMS = [
  { label: "Files", count: 12, icon: "doc" },
  { label: "Food Logs", count: 8, icon: "leaf" },
  { label: "Notes", count: 3, icon: "pencil" },
  { label: "Recordings", count: 1, icon: "mic" },
  { label: "Integrations", count: 1, icon: "link" },
];

// ─── SVG micro icons ────────────────────────────────────────────────────────

function LibIcon({ type, color }) {
  const s = { width: 14, height: 14, display: "block" };
  const p = {
    fill: "none",
    stroke: color,
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };
  switch (type) {
    case "doc":
      return (
        <svg style={s} viewBox="0 0 24 24" {...p}>
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <path d="M14 2v6h6" />
          <path d="M9 13h6M9 17h4" />
        </svg>
      );
    case "leaf":
      return (
        <svg style={s} viewBox="0 0 24 24" {...p}>
          <path d="M6 21c3-3 4-8 4-13 4 0 9 1 9 8s-6 6-13 5z" />
        </svg>
      );
    case "pencil":
      return (
        <svg style={s} viewBox="0 0 24 24" {...p}>
          <path d="M17 3l4 4L7 21H3v-4z" />
        </svg>
      );
    case "mic":
      return (
        <svg style={s} viewBox="0 0 24 24" {...p}>
          <rect x="9" y="3" width="6" height="11" rx="3" />
          <path d="M5.5 11v1a6.5 6.5 0 0 0 13 0v-1M12 19v3" />
        </svg>
      );
    case "link":
      return (
        <svg style={s} viewBox="0 0 24 24" {...p}>
          <path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" />
          <path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" />
        </svg>
      );
    default:
      return null;
  }
}

// ─── Cogwheel icon ──────────────────────────────────────────────────────────

function CogIcon({ color = "var(--color-kin-muted)", size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}

// ─── Profile screen ─────────────────────────────────────────────────────────

export function MeScreen() {
  return (
    <div style={{ padding: "8px 16px 0", display: "flex", flexDirection: "column", gap: 14 }}>
      {/* Profile header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          paddingLeft: 4,
          paddingRight: 2,
        }}
      >
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            background: "rgba(165,144,255,0.15)",
            border: "1px solid rgba(165,144,255,0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <BodyText size={13} color="var(--color-kin-lavender)" weight={700}>
            SS
          </BodyText>
        </div>
        <div style={{ flex: 1 }}>
          <DisplayText size={22} color="var(--color-kin-black)" lineHeight={1.1}>
            Sverre
          </DisplayText>
        </div>
        <div
          style={{
            width: 34,
            height: 34,
            borderRadius: "50%",
            background: "rgba(254,253,251,0.8)",
            border: "1px solid rgba(255,255,255,0.9)",
            boxShadow: "0 4px 12px -4px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(12px)",
          }}
        >
          <CogIcon size={15} />
        </div>
      </div>

      {/* Search */}
      <Glass
        style={{
          padding: "10px 16px",
          display: "flex",
          alignItems: "center",
          gap: 10,
          borderRadius: 24,
        }}
      >
        <span style={{ color: "var(--color-kin-muted)", fontSize: 14 }}>⌕</span>
        <BodyText size={10} color="var(--color-kin-muted)" weight={600}>
          Search your vault…
        </BodyText>
      </Glass>

      {/* Health Data — preview highlights, tapping any row opens Health Data */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: 4,
          paddingRight: 4,
        }}
      >
        <ScreenLabel>HEALTH DATA</ScreenLabel>
        <BodyText size={9} color="var(--color-kin-green-soft)" weight={700}>
          See all →
        </BodyText>
      </div>
      <Glass style={{ padding: "4px 14px", borderRadius: 20 }}>
        {[
          {
            label: "Steps",
            value: "10,240",
            detail: "+8% vs 7d avg",
            color: "var(--color-kin-green-soft)",
          },
          {
            label: "Homocysteine",
            value: "12.4 umol/L",
            detail: "HIGH",
            color: "#ff6b6b",
            flag: true,
          },
          {
            label: "Sleep",
            value: "7.2h",
            detail: "avg last 7 nights",
            color: "var(--color-kin-lavender)",
          },
        ].map((item, i) => (
          <div
            key={item.label}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "9px 0",
              borderBottom: i < 2 ? "1px solid rgba(0,0,0,0.04)" : "none",
            }}
          >
            <Dot color={item.color} size={6} />
            <BodyText size={10} color="var(--color-kin-black)" weight={600} style={{ flex: 1 }}>
              {item.label}
            </BodyText>
            <BodyText size={10} color="var(--color-kin-black)" weight={700}>
              {item.value}
            </BodyText>
            <BodyText
              size={8}
              color={item.flag ? "#ff6b6b" : "var(--color-kin-muted)"}
              weight={item.flag ? 700 : 500}
            >
              {item.detail}
            </BodyText>
            <Chevron />
          </div>
        ))}
      </Glass>

      {/* Library */}
      <ScreenLabel style={{ paddingLeft: 4 }}>LIBRARY</ScreenLabel>
      <Glass style={{ padding: "4px 16px", borderRadius: 20 }}>
        {LIBRARY_ITEMS.map((item, i) => (
          <div
            key={item.label}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "11px 0",
              borderBottom: i < LIBRARY_ITEMS.length - 1 ? "1px solid rgba(0,0,0,0.04)" : "none",
            }}
          >
            <div
              style={{
                width: 28,
                height: 28,
                borderRadius: 8,
                background: "rgba(0,0,0,0.04)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <LibIcon type={item.icon} color="var(--color-kin-muted)" />
            </div>
            <BodyText size={11} color="var(--color-kin-black)" weight={600} style={{ flex: 1 }}>
              {item.label}
            </BodyText>
            <BodyText size={10} color="var(--color-kin-muted)" weight={600}>
              {item.count}
            </BodyText>
            <Chevron />
          </div>
        ))}
      </Glass>

      {/* Sign out */}
      <div style={{ paddingTop: 4, paddingLeft: 4 }}>
        <BodyText size={10} color="var(--color-kin-muted)" weight={600}>
          Sign out
        </BodyText>
      </div>
    </div>
  );
}
